$(window).scroll(function () {
  var sticky = $(".header_section_group"),
    scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass("fixed");
  else sticky.removeClass("fixed");
});

$(document).ready(function () {
  // Video section JS

  jQuery(".video-container video").on("play", function () {
    var currentVideo = this;
 $("#pauseBtn").trigger("click");
    // Pause all other videos
    jQuery(".video-container video").each(function () {
      if (this !== currentVideo) {
        this.pause();
       
      }
    });

    // Hide play button on the current video
    jQuery(this).closest(".video-container").find(".play-gif").fadeOut(500);
  });

  jQuery(".video-container video").on("pause", function () {
    jQuery(this).closest(".video-container").find(".play-gif").fadeIn(500);
  });
 $(".ig_images").owlCarousel({
   loop: true,
  margin: 12,
  autoplay: true,
  autoplayTimeout: 1, // set to lowest possible
  autoplaySpeed: 5000, // adjust speed for smoothness
  autoplayHoverPause: false,
  smartSpeed: 5000, // match this with autoplaySpeed
  dots: false,
  nav: false,
    responsive: {
      0: {
        items: 3,
      },
      480: {
        items: 3,
      },
      700: {
        items: 6,
      },
      1000: {
        items: 6,
      },
      1100: {
        items: 13,
      },
    },
  });
   
  $(".feature-slider").owlCarousel({
    margin: 30,
    loop: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    nav: false,
    pagination: false,
    dots: true,
    navText: [
      "<i class='fa fa-angle-left'></i>",
      "<i class='fa fa-angle-right'></i>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1000: {
        items: 2,
      },
      1100: {
        items: 4,
      },
    },
  });
$(".review-slider").owlCarousel({
    margin: 30,
    loop: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    nav: true,
    pagination: false,
    dots: false,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0751/9259/8778/files/left-arrow.png' alt='Left'>",
      "<img src='https://cdn.shopify.com/s/files/1/0751/9259/8778/files/right_arrow.png' alt='Right'>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1000: {
        items: 2,
        nav: true,
      },
      1100: {
        items: 4,
        nav: true,
      },
    },
  });
  $("#result_slider").owlCarousel({
    margin: 10,
    loop: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    center:true,
    nav: true,
    pagination: true,
    dots: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0751/9259/8778/files/left-arrow.png?v=1744121059' alt='Left'>",
      "<img src='https://cdn.shopify.com/s/files/1/0751/9259/8778/files/right_arrow.png?v=1744121124' alt='Right'>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1000: {
        items: 3,
      },
      1100: {
        items: 5,
      },
    },
  });

  // Product Detail Page Slide
  (function ($) {
    jQuery("#destination-slider").owlCarousel({
      margin: 30,
      loop: false,
      slideSpeed: 300,
      paginationSpeed: 400,
      autoplay: true,
      nav: true,
      pagination: true,
      dots: false,
      navText: [
        "<img src='https://cdn.shopify.com/s/files/1/0751/9259/8778/files/prev.png' alt='Previous'>",
        "<img src='https://cdn.shopify.com/s/files/1/0751/9259/8778/files/next.png' alt='Next'>",
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1000: {
          items: 2,
        },
        1100: {
          items: 3,
        },
      },
    });
  })(jQuery);

  // FAQ JS

  jQuery(".accordion-heading").click(function (e) {
    if (!$(this).closest(".accordion-box").hasClass("open")) {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    } else {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });

  const itemsToShow = 4;
  const $videos = $(".h-review-area .col-md-3");
  const $loadMoreBtn = $("#loadMoreBtn");

  $videos.hide();
  $videos.slice(0, itemsToShow).show();

  $loadMoreBtn.on("click", function () {
    const currentlyVisible = $(".h-review-area .col-md-3:visible").length;
    $videos.slice(currentlyVisible, currentlyVisible + itemsToShow).fadeIn();

    if ($(".h-review-area .col-md-3:visible").length === $videos.length) {
      $loadMoreBtn.hide();
    }
  });
});

$(document).ready(function () {
  function handleFewItemsClass() {
    if ($(window).width() <= 767) {
      $(".product-area").removeClass("few-items");
    }
  }

  handleFewItemsClass();

  $(window).on("resize", function () {
    handleFewItemsClass();
  });
});
 
const audio = document.querySelector('.audio_bg');
  const pauseBtn = document.getElementById('pauseBtn');
  const playBtn = document.getElementById('playBtn');

  pauseBtn.addEventListener('click', () => {
    audio.pause();
    pauseBtn.style.display = 'none';
    playBtn.style.display = 'flex';
  });

  playBtn.addEventListener('click', () => {
    audio.play();
    playBtn.style.display = 'none';
    pauseBtn.style.display = 'flex';
  });


//   function removeDotZeroZero(node) {
//     if (node.nodeType === Node.TEXT_NODE) {
//       node.textContent = node.textContent.replace(/\.00/g, '');
//     } else {
//       node.childNodes.forEach(removeDotZeroZero);
//     }
//   }

//   // Start from the body
// setTimeout(function(){
//     removeDotZeroZero(document.body);
// },2000);

//Popup Width JS Control
(function () {
  function fixSendvilPopup() {
    const popup = document.querySelector('.ecomsend__Modal__Content');
    const image = document.querySelector('.ecomsend__Modal__CustomPic');

    if (window.innerWidth >= 1200) {
      // Popup
      if (popup) {
        popup.style.setProperty('width', '1080px', 'important');
        popup.style.setProperty('max-width', '1080px', 'important');
      }

      // Image
      if (image) {
        image.style.setProperty('width', '530px', 'important');
        image.style.setProperty('height', '698px', 'important');
        image.style.setProperty('max-width', '530px', 'important');
      }

    } else if (window.innerWidth >= 769) {
      // Tablet / smaller desktop
      if (popup) {
        popup.style.setProperty('width', 'calc(100% - 40px)', 'important');
        popup.style.setProperty('max-width', '1080px', 'important');
      }

      if (image) {
        const imageWidth = Math.min(530, (window.innerWidth - 40) * 0.49);
        const imageHeight = imageWidth * (698 / 530);

        image.style.setProperty('width', imageWidth + 'px', 'important');
        image.style.setProperty('height', imageHeight + 'px', 'important');
        image.style.setProperty('max-width', imageWidth + 'px', 'important');
      }
    }
  }

  fixSendvilPopup();

  const observer = new MutationObserver(fixSendvilPopup);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', fixSendvilPopup);
})();